/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiSkeletonText, EuiText } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'
import { useGetOktaUserProfile } from '@modules/users-lib'

import type { FunctionComponent } from 'react'

type Props = {
  userId: string
}

const OktaStatus: FunctionComponent<Props> = ({ userId }) => {
  const { data, isLoading } = useGetOktaUserProfile(userId)

  return (
    <EuiSkeletonText size='s' lines={1} isLoading={isLoading}>
      <EuiText size='s'>
        {data?.status || <FormattedMessage id='okta-user-status.none' defaultMessage='Unknown' />}
      </EuiText>
    </EuiSkeletonText>
  )
}

export default OktaStatus
